<template>
  <v-container>

    <page-title title="Billing Overview">
    </page-title>

    <v-row>
      <v-col cols="12"
             sm="4">
        <v-card>
          <v-card-text class="text-center">
            <div>
              Users
            </div>
            <h1 class="mb-2 font-weight-light text-h4">
              {{ team.licensed_users }} / {{ team.max_users }}
            </h1>
            <v-btn :to="{name: 'users'}"
                   outlined
                   small>
              Manage Users
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12"
             sm="4">
        <v-card>
          <v-card-text class="text-center"
                       v-if="team.is_billing_yearly">
            <div>
              Yearly Payment
            </div>
            <h1 class="mb-2 font-weight-light text-h4">
              {{ yearlyPayment | money }}
            </h1>
            <add-seats-dialog>
            </add-seats-dialog>
          </v-card-text>
          <v-card-text class="text-center"
                       v-else>
            <div>
              Monthly Payment
            </div>
            <h1 class="mb-2 font-weight-light text-h4">
              {{ monthlyPayment | money }}
            </h1>
            <add-seats-dialog>
            </add-seats-dialog>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12"
             sm="4">
        <v-card>
          <v-card-text class="text-center">
            <div>
              Current Plan
            </div>
            <h1 class="mb-2 font-weight-light text-h4">
              <template v-if="pricingPlan">
                {{ pricingPlan.name }}
              </template>
            </h1>
            <v-btn outlined
                   small
                   disabled>
              Manage Subscription
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row>

      <v-col cols="12"
             sm="6">
        <v-card>
          <v-card-title>
            <div>
              Billing Details
            </div>
            <v-spacer></v-spacer>
            <v-btn :to="{name: 'billing_details.edit'}"
                   icon>
              <v-icon>
                fal fa-fw fa-pencil
              </v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <div class="d-flex justify-space-between">
              <div>
                Company
              </div>
              <div>
                {{ team.name }}
              </div>
            </div>

            <div class="d-flex justify-space-between">
              <div>
                Billing Contact
              </div>
              <div>
                {{ billingContact ? billingContact.name : '' }}
              </div>
            </div>

            <div class="d-flex justify-space-between">
              <div>
                Payment method
              </div>
              <div>
                <div v-if="team.billing_invoice">
                  Invoice
                </div>
                <div v-else
                     class="d-flex justify-space-between">
                  <v-icon class="mr-2">
                    fab fa-fw fa-cc-{{ team.card_brand }}
                  </v-icon>
                  <div class="mr-2">
                    ****
                  </div>
                  <div>
                    {{ team.card_last_four }}
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex justify-space-between">
              <div>
                Next Billing Date
              </div>
              <div>
                {{ team.license_end_date | datetime('MMMM D, YYYY') }}
              </div>
            </div>

            <div class="d-flex justify-space-between">
              <div>
                Billing Country
              </div>
              <div>
                {{ team.billing_country }}
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12"
             sm="6"
             v-if="mostRecentInvoice">
        <v-card>
          <v-card-title>
            Paid Invoice #{{ mostRecentInvoice.id }}
          </v-card-title>
          <v-card-text>
            <div class="d-flex justify-space-between">
              <div>
                Amount
              </div>
              <div>
                ${{ mostRecentInvoice.total }}
              </div>
            </div>
            <div class="d-flex justify-space-between">
              <div>
                Billing Date
              </div>
              <div>
                {{ mostRecentInvoice.created_at | datetime('MMMM D, YYYY') }}
              </div>
            </div>
            <div class="d-flex justify-space-between">
              <div>
                &nbsp;
              </div>
              <div>
                &nbsp;
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn outlined
                   disabled>
              See Invoice History
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import AddSeatsDialog from "./components/AddSeatsDialog";
import pricingPlanService from "../../../../ml/services/pricingPlanService";
import {find, orderBy} from 'lodash';
import PageTitle from "../../components/PageTitle";
import invoiceService from "../../services/invoiceService";

export default {
  components: {PageTitle, AddSeatsDialog},
  data() {
    return {
      form: new Form({}),
      invoices: [],
      pricingPlan: null,
    }
  },
  computed: {
    ...mapGetters([
      'activeUsers',
      'team',
      'user',
      'users',
    ]),
    billingContact() {
      return find(this.users, u => u.id === this.team.owner_id);
    },
    monthlyPayment() {
      return this.team.max_users * (this.team.license_price / 100);
    },
    yearlyPayment() {
      return this.team.max_users * (this.team.license_price / 100) * 12;
    },
    mostRecentInvoice() {
      const invoices = orderBy(this.invoices, ['created_at'], ['desc']);
      if (invoices.length) {
        return invoices[0];
      }
      return null;
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.$store.dispatch('fetchUsers');

      if (this.team.billing_cc) {
        invoiceService.getInvoices()
          .then(data => {
            this.invoices = data.local;
          })
      }

      pricingPlanService.getPlan(this.team.pricing_plan_id)
        .then(data => {
          this.pricingPlan = data;
        });
    },
    submit() {

    }
  }
}
</script>
